// src/utils/constants.js

export const COMPANY = {
  name: "Aimble I.T. Solutions",
  tagline: "Smart Tech. Real Results. Philippine-Born, World-Ready.",
  address: "Purok 1, Tabon-tabon, Irosin, Sorsogon, Philippines",
  facebook: "https://www.facebook.com/aimbleph/",
  email: "info@aimbletech.com",
  domain: "https://www.aimbletech.com",
  phone: "",
  googleCalendar: "https://calendar.app.google/y15Ur5NnKqAPpiNw8",
};

// ─── SERVICE PACKAGES ──────────────────────────────────────────────────────
export const PACKAGES = [
  {
    id: "starter",
    name: "Starter Site",
    price: 15000,
    priceMax: 25000,
    billingType: "one-time",
    badge: null,
    description: "Perfect for small businesses launching online.",
    features: [
      "5-page responsive website",
      "Mobile-friendly design",
      "Contact form with email notifications",
      "Basic SEO setup",
      "1-year Firebase hosting",
      "Google Maps integration",
      "Social media links",
    ],
    cta: "Get Started",
    color: "blue",
  },
  {
    id: "business-pro",
    name: "Business Pro",
    price: 35000,
    priceMax: 80000,
    billingType: "one-time",
    badge: "Most Popular",
    description: "For growing businesses that need more power.",
    features: [
      "Everything in Starter",
      "Custom web application",
      "Admin/CMS panel",
      "Google & Facebook login",
      "Client portal access",
      "Domain setup assistance",
      "3 months maintenance",
    ],
    cta: "Get Started",
    color: "teal",
  },
  {
    id: "commerce",
    name: "Commerce Bundle",
    price: 80000,
    priceMax: 150000,
    billingType: "one-time",
    badge: null,
    description: "Full e-commerce or payment-enabled web system.",
    features: [
      "Everything in Business Pro",
      "Maya payment gateway integration",
      "Credit card / GCash / QR payments",
      "Automated invoice & receipt generation",
      "Official BIR-compliant receipts",
      "Subscription/recurring billing",
      "6 months maintenance",
    ],
    cta: "Get Started",
    color: "purple",
  },
  {
    id: "enterprise",
    name: "Enterprise System",
    price: 150000,
    priceMax: null,
    billingType: "one-time",
    badge: null,
    description: "Full custom systems for institutions and corporations.",
    features: [
      "Everything in Commerce Bundle",
      "Enrollment / HR / ERP system",
      "Full admin dashboard",
      "Multi-user roles & permissions",
      "Data analytics & reporting",
      "API integrations",
      "1-year maintenance included",
    ],
    cta: "Request Quote",
    color: "amber",
  },
  {
    id: "va-monthly",
    name: "VA Monthly",
    price: 8000,
    priceMax: 20000,
    billingType: "monthly",
    badge: null,
    description: "Reliable virtual assistant services for your business.",
    features: [
      "Customer support",
      "Data entry & management",
      "Email & calendar management",
      "Lead generation",
      "Social media assistance",
      "Bookkeeping support",
    ],
    cta: "Subscribe",
    color: "coral",
  },
  {
    id: "maintenance",
    name: "Maintenance Plan",
    price: 3000,
    priceMax: 8000,
    billingType: "monthly",
    badge: null,
    description: "Keep your site fast, secure, and up-to-date.",
    features: [
      "Monthly content updates",
      "Bug fixes & patches",
      "Hosting & uptime monitoring",
      "Security updates",
      "Monthly report",
      "Priority support",
    ],
    cta: "Subscribe",
    color: "gray",
  },
];

// ─── PHYSICAL / SHOP SERVICES ───────────────────────────────────────────────
export const SHOP_SERVICES = [
  {
    title: "Tax Preparation & Compliance",
    desc: "Accurate bookkeeping, tax filing, and BIR compliance services to keep your business running smoothly and penalty-free.",
    icon: "📊"
  },
  { id: "printing", icon: "🖨️", name: "Printing Services", desc: "Black & white and color printing, bond paper, and document printing." },
  { id: "photocopy", icon: "📄", name: "Photocopy", desc: "Fast and affordable photocopying services." },
  { id: "photo-dev", icon: "📷", name: "Photo Development", desc: "Print your digital photos. We have a camera for on-site shoots too." },
  { id: "pc-rental", icon: "🖥️", name: "PC Rental", desc: "Hourly computer rental for browsing, gaming, or work." },
  { id: "meta-quest", icon: "🥽", name: "Meta Quest Rental", desc: "Experience VR — rent our Meta Quest headset by the hour." },
  { id: "merchandise", icon: "🖱️", name: "Tech Merchandise", desc: "Mice, keyboards, bond paper, peripherals, and tech accessories available in-store." },
];

// ─── MAYA PAYMENT FEE STRUCTURE ─────────────────────────────────────────────
export const MAYA_FEES = {
  // When Aimble processes payment on behalf of a client
  qrCode: {
    label: "QR Code (via Aimble gateway)",
    birTax: 0.03,      // 3% BIR sales tax remittance
    mayaFee: 0.015,    // 1.5% Maya processing fee
    buffer: 0.005,     // 0.5% Aimble buffer
    total: 0.05,       // Total: 5%
    description: "5% total deduction (3% BIR + 1.5% Maya + 0.5% buffer)",
  },
  creditCard: {
    label: "Credit Card (via Aimble gateway)",
    birTax: 0.03,      // 3% BIR sales tax
    mayaFee: 0.03,     // 3% Maya CC processing
    buffer: 0.005,     // 0.5% buffer
    total: 0.065,      // Total: 6.5%
    description: "6.5% total deduction (3% BIR + 3% Maya + 0.5% buffer)",
  },
  personalQr: {
    label: "Personal QR Code (client's own)",
    birTax: 0,
    mayaFee: 0,
    buffer: 0,
    total: 0,
    description: "Free — client uses their own Maya QR code",
  },
};

// ─── PORTFOLIO PROJECTS ─────────────────────────────────────────────────────
export const PROJECTS = [
  {
    id: "insighted",
    title: "Insighted Portal",
    description: "A data-driven decision support system designed to optimize faculty class scheduling. It features integrated modules and administrative dashboards to significantly streamline academic planning operations.",
    link: "https://fac-dss.web.app/",
    image: "/insigthEd.png", // Be sure to add this image to your public folder!
    tags: ["Decision Support System", "Portal", "Fullstack", "Firebase"],
    year: 2025,
  },
  {
    id: "myrtle",
    title: "Myrtle Christian School",
    description: "A comprehensive school portal featuring enrollment processing, faculty directories, and campus announcements. It also includes integrated payment management and a dedicated portal for parents.",
    link: "https://myrtlechristianschool.com/",
    image: "/myrtle.png",
    tags: ["Education", "Web Development", "Fullstack", "Enrollment System"],
    year: 2026,
  },
  {
    id: "tobaco",
    title: "Tobaco College",
    description: "An institutional platform for Tobacoco College showcasing academic programs, admission guidelines, and the latest school updates to keep the campus community informed and engaged.",
    link: "https://tobacocollegeedu.web.app/",
    image: "/tabaco.png",
    tags: ["Education", "Firebase", "Web Development", "Fullstack"],
    year: 2026,
  },
  {
    id: "gocow",
    title: "AJASCOOPIA",
    description: "A streamlined online canteen ordering system with dedicated portals for students and staff. It categorizes meals, snacks, and supplies to effectively eliminate long cafeteria lines and maximes students' time.",
    link: "https://ajascoopia.vercel.app/",
    image: "/gocow.png",
    tags: ["E-Commerce", "Ordering System", "Fullstack", "Web Development"],
    year: 2025,
  },
  {
    id: "supliichain",
    title: "SupliiChain",
    description: "Supply chain management system for streamlining procurement and inventory.",
    link: "https://www.supliichain.com/",
    image: "/suplichain.png",
    tags: ["ERP", "Supply Chain"],
    year: 2024,
  },
  {
    id: "votingSystem",
    title: "VotingSystem",
    description: "A secure, full-stack web application designed to streamline student government elections and ensure transparent, automated vote tallying.",
    link: "https://gallanosassgvotingsystem.vercel.app/",
    image: "/gallanosa.png",
    tags: ["Voting System", "fullstack"],
    year: 2023,
  },
];

export const TESTIMONIALS = [
  {
    quote: "The team transformed our outdated site into a fast, modern, and mobile-friendly platform. We've seen a 40% boost in online inquiries since launch!",
    name: "Maria C.",
    role: "Owner, AJSCOOPIA",
  },
  {
    quote: "Their team is professional, responsive, and really understands small business needs. Highly recommended for any web project.",
    name: "Ryan W.",
    role: "Founder, SupliChain",
  },
  {
    quote: "We needed an enrollment system fast. Aimble delivered on time and within budget. The client portal makes managing our renewals so easy.",
    name: "Admin Team",
    role: "Myrtle Christian School",
  },
];


// data/constants.js
export const TEAM_MEMBERS = [
  {
    id: "ailen",
    name: "Ailen S. Laguda, LPT, MIS",
    role: "Founder & Lead Developer | Shopify Store Manager | IT Instructor | Full-Stack Web Developer | Customer Support Specialist & Project Manager",
    photo: "/ailen.png",
    contact: {
      phone: "+63919 009 3052",
      email: "ailenslaguda@gmail.com",
      location: "Irosin, Sorsogon",
      website: "https://aimbletech.com",
      upwork: "https://www.upwork.com/freelancers/~~2cdf45fbb388c4ca",
    },
    summary:
      "A seasoned technology professional and educator with a background spanning over a decade in virtual assistance and full-stack development. Combining a rigorous academic background with practical industry experience to deliver robust, data-driven solutions and reliable client support.",
    expertise: [
      "MERN Stack (MongoDB, Express, React, Node.js)",
      "Progressive Web Apps (PWA)",
      "Firebase & Firestore",
      "Agile & Scrum Methodologies",
      "Shopify Store Setup, Customization & App Integrations",
      "Cybersecurity & Computer Security Incident Handling (CSIH)",
      "E-commerce Operations (Amazon, ShipStation, Magento)",
      "Customer Support (Gorgias, Zendesk, Ticket Management)",
      "Software Engineering & Project Management",
      "Instruction & Module Development",
    ],
    skills: {
      cybersecurity: [
        "Computer Security Incident Handling (CSIH Level I)",
        "Network Defense",
        "SIEM Tools",
        "Risk Assessment (via Google Cybersecurity Certificate)",
      ],
      customerSupport: [
        "Gorgias",
        "Shopify",
        "Amazon",
        "Zendesk",
        "Ticket Management",
        "Email/Phone Support",
      ],
      techStack: [
        "HTML",
        "CSS",
        "JavaScript",
        "ReactJS",
        "NodeJS",
        "MongoDB",
        "SQL",
        "MVC",
        "Java",
        "Shopify",
      ],
      ecommercePlatforms: [
        "Shopify (product listing, refund handling)",
        "ShipStation",
        "Amazon Seller Central",
        "Magento",
      ],
      others: [
        "Xero",
        "MS Excel",
        "Photoshop",
        "MS Office 365",
        "Video Editing",
        "Appointment Setting",
        "Slack",
      ],
    },
    experience: [
      {
        title: "Instructor I",
        organization: "Sorsogon State University – Bulan Campus, College of Information and Communications Technology",
        timeline: "2025 – Present",
        description:
          "BS Information Systems core faculty. Handles Software Engineering, Project Management, and Capstone Projects. Utilizing Scrum frameworks for software development life cycles.",
      },
      {
        title: "Founder & Lead Developer / Full Stack Web Developer | Shopify Store Manager",
        organization: "Aimble I.T. Solutions",
        timeline: "2023 – Present",
        description:
          "Focuses on Shopify store setup, customization, app integrations, and MERN stack development. Leads project lifecycles and coordinates with teams to deliver scalable web solutions. Handles product updates, orders, customer support, and store maintenance for Shopify clients. Architecting web systems, enrollment applications, and providing dedicated virtual assistant services to B2B clients.",
      },
      {
        title: "Customer Support Specialist (Voice, Chat, and Email)",
        organization: "Allguard Inc.",
        timeline: "2020 – Present",
        description:
          "Delivered exceptional phone-based support for U.S. customers. Handled billing, account resolution, and product inquiries. Beyond support duties, spearheaded the development of several internal utility tools to streamline operations, including a full-stack ERP system designed to centralize and automate key business processes across departments.",
      },
      {
        title: "CSR & Product Support – E-commerce",
        organization: "CarCovers.com, Freelance & Upwork Clients",
        timeline: "2020 – Present",
        description:
           "Provided post-sales customer support via Gorgias and Zendesk. Handled product listings, refunds, and order edits via Shopify and Amazon. Used ShipStation for tracking, order fulfillment, and ticket resolution. Across Upwork engagements, also designed and developed several websites and web applications for international clients, and performed transcription work spanning audio, video, and document-based content.",
      },
      {
        title: "Teacher I | Teacher III | Master Teacher II (Senior High Programming & IT)",
        organization: "Department of Education",
        timeline: "2015 – 2024",
        description:
          "Taught IT and programming-related subjects, including Capstone and Research. Mentored students in software development and cybersecurity fundamentals. Conducted trainings as a CSIH Level I Instructor. Served as a dedicated public school educator for 9 years before transitioning fully into tech agency leadership.",
      },
      {
        title: "Freelance Admin / Virtual Assistant",
        organization: "Upwork.com",
        timeline: "2009 – Present",
        description:
          "Project management, data entry, tech support. Collaborated with international clients in web and e-commerce projects.",
      },
    ],
    education: [
      {
        degree: "Doctor in Information Technology",
        institution: "La Consolacion University Philippines",
        year: "May 2026 – Present",
        status: "In Progress",
      },
      {
        degree: "Master in Information Systems (MIS)",
        institution: "Bicol University School of Graduate Studies",
        year: "2017 – 2023",
        status: "Completed",
      },
      {
        degree: "BS in Computer Science",
        institution: "Bicol University Gubat Campus",
        year: "2006 – 2011",
        status: "Completed",
      },
      {
        degree: "Full Stack Web Development Bootcamp",
        institution: "Zuitt Coding Bootcamp",
        year: "2022",
        status: "Completed",
      },
      {
        degree: "JAVA Programming NC III",
        institution: "Technical Vocational",
        year: "",
        status: "Completed",
      },
    ],
    certifications: [
      "Maryland Initial Teaching Certificate & Illinois Professional Teaching License | Computer Science, Technology Education, Mathematics",
      "TESDA-accredited Computer Security Incident Handling (CSIH) Level I Instructor",
      "Licensed Professional Teacher (LPT)",
      "Google Cybersecurity Professional Certificate – Coursera (2025)",
      "Bookkeeping NC III | Computer Systems Servicing NC II | Trainer's Methodology I",
      "Civil Service Professional & LET Passer",
    ],
    publications: [
      {
        title:
          "Development of a Data-Driven Class Scheduling Optimization Decision Support System with an Integrated Defense Scheduling Module",
        journal: "Discover Education",
        status: "Peer Review",
      },
      {
        title:
          "Human Interaction with Generative AI in Computing Education: Vibe Coding Adoption, Outcomes, and Policy",
        journal: "International Journal of Educational Technology in Higher Education",
        collection: "Human Interaction with Gen AI Across Learning and Teaching Processes in Higher Education",
        status: "Editorial Assignment",
      },
      {
        title:
          "Katutubo in the Digital Age: Technology Adoption and Cultural Continuity Among the Agta-Tabangnon of Cogon, Irosin, Sorsogon, Philippines",
        journal: "AlterNative",
        status: "Peer Review",
      },
    ],
    ongoingResearch: [
      {
        title:
          "InsightEd: Design and Development of a Web-Based Faculty Decision Support and Academic Management System for Higher Education Institutions",
      },
      {
        title:
          "Taniman AI: Design and Prototyping of an AI-Powered Portable Crop Disease Detection Kiosk with Bilingual Tagalog-Bikol Interface for Rural Filipino Farmers",
      },
      {
        title:
          "Poverty Porn in Digital Media: An Augustinian Ethical Evaluation of Content Creators' Representation of Filipino Poverty",
      },
    ],
  },
];